// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bookPopText{z-index:999;top:20%;background-color:#fff;position:absolute;overflow:hidden scroll;margin:10px;border-radius:10px;padding:15px;min-height:300px;max-height:70%}.bookPopAlimImg{width:100px;right:20px;position:absolute;float:right}", ""]);
// Exports
module.exports = exports;
